// extracted by mini-css-extract-plugin
module.exports = {"root":"📦SampleForm__root--1c-QW","labelledValue":"📦SampleForm__labelledValue--3_gvG","footer":"📦SampleForm__footer--332xM","sampleError":"📦SampleForm__sampleError--1Qj19"};